import React, { useState } from "react";
import { Video } from "lucide-react";
import ChatAdvisor from "./ChatAdvisor";
import { analytics } from "../utils/analytics";
import { useTranslation } from "react-i18next";

const FloatingActions: React.FC = () => {
  const { t } = useTranslation();
  const [showVideoAvatar, setShowVideoAvatar] = useState(false);

  const handleVideoAvatarOpen = () => {
    analytics.track("video_avatar_opened", "engagement");
    setShowVideoAvatar(true);
  };

  const handleVideoAvatarClose = () => {
    analytics.track("video_avatar_closed", "engagement");
    setShowVideoAvatar(false);
  };

  return (
    <>
      {/* Chat Advisor Component - already has its own floating button */}
      <ChatAdvisor />
    </>
  );
};

export default FloatingActions;
